
import { useApiStore } from "@/stores/apiStore";
import { useAuthStore } from "@/stores/authStore";
import { useToastStore } from "@/stores/toastStore";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import { LANGUAGES } from "@/utils/Languages";

export default defineComponent({
	setup() {
		const api = useApiStore();
		const authStore = useAuthStore();
		const toast = useToastStore();
		const { user: authUser } = storeToRefs(authStore);
		return { api, authStore, authUser, toast };
	},
	name: "imdex-preferences",
	data() {
		return {
			defaultMineSite: "",
			language: "",
			languageOptions: LANGUAGES,
			timezone: "",
			isLoading: false,
			availableSites: []
		};
	},
	async mounted() {
		await this.getSites();
		const userSite = this.availableSites.filter((item: any) => {
			return item.value == (this.authUser as AuthUser).userPreferences.defaultSite;
		});
		if (userSite.length > 0) {
			this.defaultMineSite = (this.authUser as AuthUser).userPreferences.defaultSite;
		}

		this.timezone = (this.authUser as AuthUser).userPreferences.timeZone;
		this.language = (this.authUser as AuthUser).userPreferences.language;
	},
	methods: {
		async getUser() {
			const route = "/user/read/me";
			try {
				const { data } = await this.api.get(route);
				this.authStore.setUser(data);
				if (this.$i18n.locale !== (this.authUser as AuthUser).userPreferences.language) {
					localStorage.setItem(
						"user-prefs-language",
						(this.authUser as AuthUser).userPreferences.language
					);
					this.$i18n.locale = (this.authUser as AuthUser).userPreferences.language;
				}
			} catch (e) {
				this.authStore.logout();
			}
		},
		async submitSavePreferences() {
			this.isLoading = true;

			try {
				await this.api.put({
					endpoint: "/user-preferences/update",
					post: {
						id: this.authUser?.id,
						defaultSite: this.defaultMineSite,
						language: this.language,
						timeZone: this.timezone
					}
				});
				await this.getUser();

				// this.$t is out of scope in the setTimeout callback during cypress tests
				const translatedToastSuccessMsg = this.$t("toastGeneralSuccess");
				const translatedToastErrorMsg = this.$t("userPreferences.toastSuccessUpdate");

				setTimeout(() => {
					this.isLoading = false;
					this.toast.toast({
						title: translatedToastSuccessMsg,
						dismissable: false,
						message: translatedToastErrorMsg,
						type: "success"
					});
				}, 1000);
			} catch (e) {
				this.isLoading = false;

				this.toast.toast({
					title: this.$t("toastGeneralError"),
					dismissable: false,
					message: this.$t("userPreferences.toastErrorUpdate"),
					type: "error"
				});
			}
		},
		async getSites() {
			const { data } = await this.api.get("/site/read");
			this.availableSites = data.map((item: any) => {
				return { text: item.name, value: item.id };
			});
		}
	},

	computed: {
		availableTimezones() {
			return Intl.supportedValuesOf("timeZone").map((item) => {
				return { text: item, value: item };
			});
		}
	}
});
